'use client';

import { type FC } from 'react';
import { RelevantQuestionnaireStatusProps } from './RelevantQuestionnaireStatus.types';
import { Flex, Icon, Text, Button, ButtonGroup } from '@/_components';
import styles from './RelevantQuestionnaireStatus.module.css';
import { getClasses } from '@/_utils/classnames';

export const RelevantQuestionnaireStatus: FC<
  RelevantQuestionnaireStatusProps
> = ({ questionnaire, reloadQuestionnairePreview }) => {
  if (!questionnaire?.parent_entity_relevant_questionnaire_statuses?.length) {
    return null;
  }

  const handleNavigation = (companyId: number, questionnaireId: number) => {
    reloadQuestionnairePreview(companyId, questionnaireId);
  };

  return (
    <Flex isColumn={true} gap={2}>
      {questionnaire.parent_entity_relevant_questionnaire_statuses?.map(
        (relatedQuestionnaire, index) => {
          const onQuestionnaireClick = () =>
            handleNavigation(
              relatedQuestionnaire.company_id,
              relatedQuestionnaire.id,
            );

          const relevantQuestionnaireClasses: string = getClasses(
            styles.relevantQuestionnaireStatus,
            {
              [styles.relevantQuestionnaireStatusActive]:
                questionnaire.id === relatedQuestionnaire.id,
            },
          );

          return (
            <Flex
              gap={4}
              key={index}
              isBetween={true}
              className={relevantQuestionnaireClasses}
            >
              <Flex
                isYCentered={true}
                gap={2}
                className={styles.relevantQuestionnaireStatus__title}
              >
                <Icon
                  name={
                    relatedQuestionnaire.completed ? 'check-circle' : 'x-circle'
                  }
                  color={
                    relatedQuestionnaire.completed ? 'success' : 'critical'
                  }
                  size={20}
                />
                <Text type="small" fontWeight="medium" isEllipsis={true}>
                  {relatedQuestionnaire.name}
                </Text>
              </Flex>
              <ButtonGroup>
                <Button
                  value="Open Questionnaire"
                  onClick={onQuestionnaireClick}
                  intent="ghost"
                  size="tiny"
                  iconLeft="switch"
                />
              </ButtonGroup>
            </Flex>
          );
        },
      )}
    </Flex>
  );
};
